module.exports = __webpack_public_path__ + "78e42cf0dff32e1010dfea678e41626a.png";